/**
 * Estimated size (in pixels) used by the virtualizer to size items before
 * their real height is measured. Kept conservative to avoid large layout
 * jumps when the actual message height differs from the estimate.
 */
export const VIRTUAL_ITEM_SIZE = 60;

/**
 * Distance (in pixels) from the bottom under which the list is considered
 * "stuck to bottom" and should auto-scroll when new messages arrive.
 */
export const STICK_TO_BOTTOM_THRESHOLD = 50;

/**
 * Scroll offset (in pixels) from the top under which older history is fetched
 * by the virtualised renderer.
 */
export const LOAD_HISTORY_THRESHOLD = 200;

/**
 * Number of messages requested on each history page load.
 */
export const HISTORY_PAGE_SIZE = 20;

/**
 * Default maximum number of renderable messages kept in the store for the
 * legacy (reversed) renderer. Older messages beyond this count are removed
 * when the user reaches the bottom of the conversation.
 *
 * Override via the `messages_trim_count` configuration value.
 * Set `messages_trim_count` to `-1` to disable trimming entirely.
 */
export const DEFAULT_MESSAGES_TRIM_COUNT = 30;
